import {  Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { CategoryOptionType, TaxModuleOptionType, TaxType, TaxTypeOptionType } from './types.ts'
import {Button} from "@/components/ui/button.tsx";
import {ArrowLeft} from "lucide-react";

interface NewProps {
  tax: TaxType
  categories: CategoryOptionType[]
  tax_types: TaxTypeOptionType[]
  tax_modules: TaxModuleOptionType[]
}

export default function New({ tax, categories, tax_types, tax_modules }: NewProps) {
  return (
    <>
      <div className="p-8">
        <div className="mb-6">
          <Link href="/admin/taxes">
            <Button variant="ghost" size="sm" className="mb-4 gap-2">
              <ArrowLeft className="h-4 w-4" />
              Retour
            </Button>
          </Link>

        <h1 className="font-bold text-4xl">Créer une taxe</h1>
        </div>

        <Form
          tax={tax}
          categories={categories}
          tax_types={tax_types}
          tax_modules={tax_modules}
          method="post"
          action="/admin/taxes"
          submitText="Creer une taxe"
        />

      </div>
    </>
  )
}
